import moment from "moment";
import { useCallback } from "react";

import MeetingOverview from "@apps/meetings/components/meetings-overview";
import { useLink } from "@components/link/link-helpers";

const ExtensionMeetings = () => {
  const link = useLink();

  const handleClickMeeting = useCallback(
    (meetingId: number, meetingGroupId: number) => {
      link.redirect(`/extension/meeting/${meetingGroupId}/${meetingId}`);
    },
    [link],
  );

  return (
    <div className="bg-white">
      <MeetingOverview
        forceTodayScroll={0}
        selectedDay={moment().format("YYYY-MM-DD")}
        meetingListClassName="px-6"
        onClickMeetingLink={handleClickMeeting}
      />
    </div>
  );
};

export default ExtensionMeetings;
